import { defaultFPlusDiffLayout } from './fplusDiffLayout'
import type { ViewPreferences } from './types'

export const MAX_TAB_LIMIT = 30
export const MIN_TAB_LIMIT = 1

/**
 * How the portal is laid out for a reader who has never changed anything. Every
 * stored preference is merged over these, so a reader who stored their
 * preferences before a setting existed still gets its default.
 */
export const defaultPreferences: ViewPreferences = {
  leftSidebar: 'picker',
  templates: {
    isSidebarOpen: true,
    isFlattened: false,
    isShowingEmptyValues: false,
    isShowingNativeView: false,
    isShowingSimplifiedView: undefined,
    isShowingModelDiagram: true,
    isShowingInheritanceDiagram: true,
    isShowingSubTemplateDiagram: true,
    isFPlusHoverWithCtrlHover: false,
    isShowingNotRelevantFields: false,
  },
  parameters: {
    isSidebarOpen: true,
    isFlattened: false,
    isTimeSeriesMode: false,
    isShowingExtrinsicParameterValues: false,
  },
  glMaps: {
    isSidebarOpen: true,
  },
  reconciliationSpecs: {
    isSidebarOpen: true,
  },
  common: {
    isUsingModal: undefined,
    isShowingDocumentationOnHover: undefined,
    diffLayout: defaultFPlusDiffLayout,
  },
  tabs: {
    limit: MAX_TAB_LIMIT,
  },
}
